var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfersRcl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RCL-IconM"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 4.5,
    width: 18,
    height: 17,
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 577756",
    d: "M6 21.5H9V25C9 25.2761 8.77614 25.5 8.5 25.5H6.5C6.22386 25.5 6 25.2761 6 25V21.5Z",
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 577757",
    d: "M21 21.5H24V25C24 25.2761 23.7761 25.5 23.5 25.5H21.5C21.2239 25.5 21 25.2761 21 25V21.5Z",
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 9,
    y: 7.5,
    width: 12,
    height: 6,
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 10,
    cy: 17.5,
    r: 1,
    stroke: "#151617"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 20,
    cy: 17.5,
    r: 1,
    stroke: "#151617"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfersRcl);
export default __webpack_public_path__ + "static/media/transfers-rcl.66366e078f0f8d3b2cac927b318befa0.svg";
export { ForwardRef as ReactComponent };